import Card from "src/components/Card";
import styled from "styled-components";

export const StyledMeetingCard = styled(Card)`
    
`;

export const DivWithWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 2px 0;
`;

export const DivIcons = styled.div`
    display: flex;
    align-items: center;
    margin: 0 4px;
    padding: 0 0 1px 0;
    border-bottom: 1px solid transparent;

    >svg{
        margin-right: 2px;
    }

    transition: 100ms ease;
    
    &:hover{
        cursor: pointer;
        border-bottom: 1px solid var(--default-color-font);
    }
`;
